import {ChangeDetectorRef, Component, Input, OnDestroy, OnInit} from '@angular/core';
import {Router} from '@angular/router';
import {DcpCartService} from '@app/product/services/dcp-cart.service';
import {EntryGroupService} from '@app/product/services/entry-group.service';
import {DcpCartDecoratorService} from '@app/services/dcp-cart-decorator.service';
import {DcpEntryGroup, ProviderContractSplitGroup} from '@dcp/configurator';
import {ProvidedByComponent} from '../provided-by/provided-by.component';
import {CheckoutEntryValidationService} from '../services/checkout-entry-validation.service';
import {DcpCartHistoryService} from '../services/dcp-cart-history.service';

@Component({
  selector: 'dcp-bundle-provided-by',
  templateUrl: './bundle-provided-by.component.html',
  styleUrls: ['./bundle-provided-by.component.scss']
})
export class BundleProvidedByComponent extends ProvidedByComponent implements OnInit, OnDestroy {
  public providerGroups: ProviderContractSplitGroup[] = [];
  public providerContractCount: number;

  constructor(
    protected router: Router,
    protected cartHistoryService: DcpCartHistoryService,
    protected changeRef: ChangeDetectorRef,
    public entryGroupService: EntryGroupService,
    protected cartService: DcpCartService,
    public checkoutEntryValidationService: CheckoutEntryValidationService,
    public cartDecoratorService: DcpCartDecoratorService,
  ) {
    super(router, cartHistoryService, changeRef, cartService, cartDecoratorService);
  }

  private _entryGroups: DcpEntryGroup[] = [];

  get entryGroups(): DcpEntryGroup[] {
    return this._entryGroups;
  }

  @Input()
  set entryGroups(entryGroups: DcpEntryGroup[]) {
    this._entryGroups = entryGroups;
    this.providerGroups = this.entryGroupService.getProviderGroups(entryGroups);
  }

  @Input() displayTitle: boolean = true;

  ngOnInit(): void {
    super.ngOnInit();
    this.providerContractCount = this.entryGroupService.countProviderContracts(this.providerGroups);
  }

  ngOnDestroy() {
    super.ngOnDestroy();
  }
}
